// extracted by mini-css-extract-plugin
module.exports = {"tempType":"select-temp-type_tempType__DmZvf"};